<div class="switch-exchange-page">
  <div class="switch-exchange-panel">
    <div *ngIf="loading && !failed" class="spinner-border text-dark mb-3" role="status">
      <span class="visually-hidden">{{ 'TenantSwitch.Switching' | translate }}</span>
    </div>
    <i *ngIf="failed" class="bi bi-exclamation-triangle text-danger switch-exchange-icon" aria-hidden="true"></i>
    <h1>{{ 'TenantSwitch.SwitchTitle' | translate }}</h1>
    <p>{{ (failed ? 'TenantSwitch.Redirecting' : 'TenantSwitch.SwitchDescription') | translate }}</p>
  </div>
</div>
